import { USER_TYPES } from "consts";
import { useUserType } from "hooks/useUserType";
import { useCallback, useMemo } from "react";
import { ColumnConfig } from "components/table/table.types";
import {
  CHIRO_MEDICARE_EDITABLE_FIELDS,
  CLAIM_COLUMN,
  DEFAULT_COLUMNS,
  DOB_COLUMN,
  DOCTOR_COLUMN,
  DOCUMENTS_COLUMN,
  EDITABLE_MEDICARE_ADMIN_FIELDS,
  INSTITUTION_COLUMN,
  LOCK_COLUMN,
  MEDICARE_COLUMN,
  MOD_COLUMN,
  PATIENT_NAME_COLUMN,
  PID_COLUMN,
  PK_COLUMN,
  RADIOLOGIST_EDITABLE_FIELDS,
  SELECT_COLUMN,
  SERVICES_COLUMN,
  SEX_COLUMN,
  SORTABLE_COLUMNS,
  STATUS_COLUMN,
  STUDY_COLUMN,
  STUDY_DATE_COLUMN,
  STUDY_PROCESS_COLUMN,
  VERIFIED_COLUMN,
  XCALIBER_COLUMN,
} from "./columns.consts";
import { useHomePageContext } from "pages/home-page/context/homepage.context";

export const useColumnConfigs = () => {
  const { userType } = useUserType();
  const {
    dispatch,
    state: { sortingColumn, sortingDirection },
  } = useHomePageContext();

  const { columns, editable } = useMemo(() => {
    switch (userType) {
      //case USER_TYPES.VET_XCALIBER: {
      //  const columns = [...DEFAULT_COLUMNS, XCALIBER_COLUMN];
      //  return { columns, editable: [] };
      //}
      case USER_TYPES.ADMIN: {
        const columns = [
          SELECT_COLUMN,
          PID_COLUMN,
          STUDY_DATE_COLUMN,
          PATIENT_NAME_COLUMN,
          DOB_COLUMN,
          SEX_COLUMN,
          DOCTOR_COLUMN,
          INSTITUTION_COLUMN,
          MOD_COLUMN,
          STUDY_COLUMN,
        ];
        return { columns, editable: [] };
      }

      case USER_TYPES.MEDICARE_ADMIN: {
        const medicareAdminColumns = [
          SELECT_COLUMN,
          PK_COLUMN,
          STUDY_DATE_COLUMN,
          STUDY_PROCESS_COLUMN,
          LOCK_COLUMN,
          STATUS_COLUMN,
          PID_COLUMN,
          MEDICARE_COLUMN,
          SERVICES_COLUMN,
          PATIENT_NAME_COLUMN,
          DOB_COLUMN,
          SEX_COLUMN,
          DOCTOR_COLUMN,
          INSTITUTION_COLUMN,
          DOCUMENTS_COLUMN,
          CLAIM_COLUMN,
          VERIFIED_COLUMN,
          MOD_COLUMN,
          STUDY_COLUMN,
        ];
        return {
          columns: medicareAdminColumns,
          editable: EDITABLE_MEDICARE_ADMIN_FIELDS,
        };
      }

      case USER_TYPES.CHIRO_MEDICARE: {
        const chiroColumns = [
          SELECT_COLUMN,
          LOCK_COLUMN,
          PID_COLUMN,
          STUDY_DATE_COLUMN,
          STATUS_COLUMN,
          MEDICARE_COLUMN,
          SERVICES_COLUMN,
          PATIENT_NAME_COLUMN,
          DOB_COLUMN,
          SEX_COLUMN,
          DOCTOR_COLUMN,
          DOCUMENTS_COLUMN,
          CLAIM_COLUMN,
          VERIFIED_COLUMN,
          MOD_COLUMN,
          STUDY_COLUMN,
        ];
        return {
          columns: chiroColumns,
          editable: CHIRO_MEDICARE_EDITABLE_FIELDS,
        };
      }
      
      case USER_TYPES.DEVELOPER: {
        const developerColumns = [
          SELECT_COLUMN,
          PK_COLUMN,
          PID_COLUMN,
          STUDY_DATE_COLUMN,
          STUDY_PROCESS_COLUMN,
          LOCK_COLUMN,
          STATUS_COLUMN,
          MEDICARE_COLUMN,
          SERVICES_COLUMN,
          PATIENT_NAME_COLUMN,
          DOB_COLUMN,
          SEX_COLUMN,
          DOCTOR_COLUMN,
          INSTITUTION_COLUMN,
          DOCUMENTS_COLUMN,
          CLAIM_COLUMN,
          VERIFIED_COLUMN,
          MOD_COLUMN,
          STUDY_COLUMN,
        ];
        return {
          columns: developerColumns,
          editable: EDITABLE_MEDICARE_ADMIN_FIELDS//CHIRO_MEDICARE_EDITABLE_FIELDS,
        };
      }

      case USER_TYPES.RADIOLOGIST: {
        const radiologistColumns = [
          SELECT_COLUMN,
          PID_COLUMN,
          STUDY_DATE_COLUMN,
          STUDY_PROCESS_COLUMN,
          LOCK_COLUMN,
          STATUS_COLUMN,
          MEDICARE_COLUMN,
          SERVICES_COLUMN,
          PATIENT_NAME_COLUMN,
          DOB_COLUMN,
          SEX_COLUMN,
          DOCTOR_COLUMN,
          INSTITUTION_COLUMN,
          DOCUMENTS_COLUMN,
          CLAIM_COLUMN,
          VERIFIED_COLUMN,
          MOD_COLUMN,
          STUDY_COLUMN,
        ];
        return {
          columns: radiologistColumns,
          editable: RADIOLOGIST_EDITABLE_FIELDS,
        };
      }

      case USER_TYPES.MEDICAL:
      case USER_TYPES.DENTAL:
      case USER_TYPES.CHIRO:
      case USER_TYPES.VET:
      case USER_TYPES.VET_XCALIBER:
      case USER_TYPES.PUBLIC:
      default: {
        return {
          columns: DEFAULT_COLUMNS,
          editable: RADIOLOGIST_EDITABLE_FIELDS,
        };
      }
    }
  }, [userType]) as { columns: ColumnConfig[]; editable: string[] };

  const onColumnClick = useCallback(
    (sortingColumn: string, sortingDirection: string) => {
      dispatch({
        type: "CHANGE_SEARCH_PARAMS",
        payload: { sortingColumn, sortingDirection },
      });
    },
    [dispatch]
  );

  const sortableColumns = useMemo(() => [...SORTABLE_COLUMNS], []);
  return {
    columns,
    editable,
    onColumnClick,
    sortableColumns,
    sortingColumn,
    sortingDirection,
  };
};
